<template>
  <div class="power">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>社会责任</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <div class="text_box">
        <img class="left" src="@/assets/img/about/power/left.png" />
        <p class="content_text">
          {{ dutyTips }}
        </p>
        <img class="right" src="@/assets/img/about/power/right.png" />
      </div>
      <div class="nav">
        <div
          class="box1"
          v-for="(item, index) in list"
          :key="index"
          :style="index % 2 === 0 ? '' : 'flex-direction: row-reverse;'"
        >
          <div
            class="left_img"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
          ></div>
          <div class="box1_text">
            <p class="text_title">{{ item.title }}</p>
            <div class="line"></div>
            <p class="text_text" v-html="item.tips"></p>
          </div>
        </div>
      </div>
      <div
        class="img"
        :style="{
          backgroundImage: 'url(' + dutyImg + ')',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {
      dutyTips: "",
      dutyImg: "",
    };
  },
  methods: {
    async init() {
      this.params = this.$route.params;
      this.getAjax();
      this.dutyTips = await this.getMenuConfig("责任简介", "tips");
      this.dutyImg = await this.getMenuConfig("责任详图", "image");
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 400px;
  background: url(~@/assets/img/about/duty.png) no-repeat center;
  background-size: cover;
}
.title_text {
  position: absolute;
  top: 98px;
  left: 50%;
  margin-left: -180px;
  width: 360px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  line-height: 84px;
  text-align-last: justify;
  text-align: justify;
}
.g-box {
  transform: translateY(-120px);
}
.text_box {
  position: relative;
  width: 1100px;
  height: 200px;
  background: #ffffff;
  box-shadow: 0px 8px 16px 0px rgba(168, 170, 184, 0.2);
  margin-bottom: 100px;
}
.content_text {
  position: absolute;
  top: 76px;
  left: 50%;
  margin-left: -490px;
  width: 980px;
  height: 72px;
  font-size: 16px;
  font-weight: 400;
  color: #292a32;
  line-height: 24px;
}
.left {
  position: absolute;
  left: 20px;
  top: 20px;
}
.right {
  position: absolute;
  top: 160px;
  left: 1020px;
}
.box1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  .left_img {
    width: 420px;
    height: 280px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.box1_text {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.text_title {
  width: 600px;
  height: 45px;
  font-size: 32px;
  font-weight: 400;
  color: #0030aa;
  line-height: 45px;
}
.line {
  width: 62px;
  height: 2px;
  background: #0030aa;
}
.text_text {
  width: 620px;
  height: 96px;
  font-size: 16px;
  font-weight: 400;
  color: #656878;
  line-height: 24px;
}
.img {
  width: 1100px;
  height: 750px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  //display: flex;
  //justify-content: space-between;
  //.img1 {
  //  width: 350px;
  //  height: 500px;
  //  background: url(~@/assets/img/about/duty_img.png) no-repeat;
  //  background-size: cover;
  //}
  //.right_img {
  //  display: flex;
  //  justify-content: space-between;
  //  align-content: space-between;
  //  flex-wrap: wrap;
  //  width: 730px;
  //  .img2 {
  //    width: 350px;
  //    height: 240px;
  //    background: url(~@/assets/img/about/duty_img.png) no-repeat;
  //    background-size: cover;
  //  }
  //  .img3 {
  //    width: 350px;
  //    height: 240px;
  //    background: url(~@/assets/img/about/duty_img.png) no-repeat;
  //    background-size: cover;
  //  }
  //  .img4 {
  //    width: 730px;
  //    height: 240px;
  //    background: url(~@/assets/img/about/duty_img.png) no-repeat;
  //    background-size: cover;
  //  }
  //}
}
</style>
